import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../..";
import { UpdateProductsSort } from "../../../Redux/Actions/ProductListActions";
import CaretDownIcon from "../../../Images/Icons/Global/CaretDownIcon";

import "./Styles/_ProductsSortDropdown.scss";

// Values must match the backend ProductSort enum names (sent verbatim). Ordered alphabetically by
// label — keep new options in alphabetical position.
export const SORT_OPTIONS: { value: string; label: string }[] = [
    { value: "NameAsc", label: "Name: A–Z" },
    { value: "NameDesc", label: "Name: Z–A" },
    { value: "PriceDesc", label: "Price: High–Low" },
    { value: "PriceAsc", label: "Price: Low–High" },
    { value: "SkuAsc", label: "SKU: A–Z" },
    { value: "SkuDesc", label: "SKU: Z–A" },
    { value: "StockDesc", label: "Stock: High–Low" },
    { value: "StockAsc", label: "Stock: Low–High" },
];

const ProductsSortDropdown = (): JSX.Element => {
    const dispatch = useDispatch();
    const sort = useSelector((state: RootState) => state.productListReducer.filter.sort);
    const [open, setOpen] = useState(false);

    // No match (sort is blank/deselected) is a valid state now - it's what tells the backend to
    // fall back to its own default order (ProductSort.Default) instead of forcing NameAsc.
    const activeOption = SORT_OPTIONS.find((option) => option.value === sort);

    // Clicking the already-active option again deselects it rather than being a no-op, since
    // deselecting is the only way to reach the blank/default sort from this dropdown.
    const onSelect = (value: string) => {
        setOpen(false);
        const nextValue = value === sort ? "" : value;
        if (nextValue !== sort) {
            dispatch(UpdateProductsSort(nextValue));
        }
    };

    return (
        <div className="products-sort">
            <span className="products-sort-label">Sort by</span>
            <div className="products-sort-dropdown">
                <button
                    type="button"
                    className="default-button outline products-sort-trigger"
                    onClick={() => setOpen((prev) => !prev)}
                >
                    <span className="products-sort-selected">{activeOption ? activeOption.label : ""}</span>
                    <CaretDownIcon strokeColor="#393939" />
                </button>
                {open && (
                    <>
                        <div className="dropdown-cover" onClick={() => setOpen(false)} />
                        <div className="products-sort-menu">
                            {SORT_OPTIONS.map((option) => (
                                <button
                                    type="button"
                                    key={option.value}
                                    className={option.value === sort ? "active" : ""}
                                    onClick={() => onSelect(option.value)}
                                >
                                    <span className="checkmark">{option.value === sort ? "✓" : ""}</span>
                                    {option.label}
                                </button>
                            ))}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ProductsSortDropdown;
